import { useMutation } from "@tanstack/react-query";
import React, { useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import { createUser } from "../api/authAPI";
import Spinner from "../components/UI/Spinner";
import TextField from "../components/UI/TextField";
import { useAuthStore } from "../store/authStore";

import bg from "../assets/signInBg.png";
import LoginHeader from "../components/UI/LoginHeader";
import { useNavigate } from "react-router-dom";
import { validatePassword } from "../helpers/commonFunction";
import { ToastContainer, toast } from "react-toastify";

const SignUpPage = () => {
  const {
    register,
    handleSubmit,
    getValues,
    reset,
    watch,
    formState,
  } = useForm();
  const addUser = useAuthStore((state) => state.addUser);
  const { isLoading, isSuccess, mutate, data, error } = useMutation({
    mutationFn: createUser,
  });
  const type = watch("registerType")
  const password = watch("password")
  const email = watch("email")
  const [isEnterprise, setEnterprise] = useState(false)
  useEffect(() => {
    if (type == "enterprise") {
      setEnterprise(true)
    } else {
      setEnterprise(false)
    }
  }, [type, formState])
  const navigate = useNavigate();
  const mobile = watch("mobile")
  // hit api on submit
  const submitlogin = () => {
    if (!(email?.includes("@"))) {
      return toast.error("Please Enter valid email id")
    }
    const payload = getValues();
    if (mobile.length !== 10) {
      return toast.error("Incorrect Mobile Number")
    }
    if (validatePassword(password)) {
      mutate(payload);
      // reset form
      reset();
    } else {
      toast.error("Password Guidelines:\n Atleast 8 character \n Special character@#$%^&* \n Atleast one letter a-z", { style: { whiteSpace: "pre-line" } })
      // toast.error("Atleast 8 character" + "\n" + "Special character@#$%^&*")
    }
  };
  useEffect(() => {
    if (isSuccess && data) {
      // add user to store
      addUser(data.data.data);
      // navigate to otp page
      navigate("/verifyotp");
    }
  }, [isSuccess]);

  useEffect(() => {
    toast.error(error?.response?.data?.message)
  }, [error])
  return (
    <div className="login-wrap w-screen h-screen flex items-center justify-center bg-slate-100">
      <ToastContainer />
      <img className="absolute w-full h-full" src={bg} alt="bg" />

      <div className="login-card z-10 w-fit p-8 bg-white rounded-xl">
        <LoginHeader />
        <br />
        <h1 className="text-3xl font-light">Sign Up</h1>
        <br />
        <form onSubmit={handleSubmit(submitlogin)} className="form">
          <div className="grid">
            <div className="grid grid-cols-2 gap-2">
              <TextField
                label="full name"
                placeholder={"Enter your full name"}
                inputProps={{ ...register("fullName", { required: true }) }}
              />
              <TextField
                label="mobile"
                placeholder={"Enter your Mobile no."}
                inputProps={{ ...register("mobile", { required: true }) }}
              />
              <TextField
                label="email"
                type="email"
                placeholder={"Enter your email"}
                inputProps={{ ...register("email", { required: true }) }}
              />
              <TextField
                label="password"
                placeholder={"Enter your password"}
                type="password"
                inputProps={{ ...register("password", { required: true }) }}
              />
              <div className="user-type col-span-2">
                <h1>User type</h1>
                <div className="flex mt-2">
                  <div className="flex items-center mb-4">
                    <input {...register("registerType", { required: true })} id="default-radio-1" type="radio" value="individual" className="cursor-pointer w-4 block h-4 outline-none focus:border-none text-blue-600 bg-gray-100 border-gray-300 focus:ring-blue-500 dark:focus:ring-blue-600 dark:ring-offset-gray-800 focus:ring-2 dark:bg-gray-700 dark:border-gray-600" />
                    <label htmlFor="default-radio-1" className="ml-2 block text-sm font-medium text-gray-900 dark:text-zinc-400">Individual</label>
                  </div>
                  &ensp;
                  <div className="flex items-center mb-4">
                    <input {...register("registerType", { required: true })} id="default-radio-2" type="radio" value="enterprise" className="cursor-pointer w-4 h-4 outline-none focus:border-none text-blue-600 bg-gray-100 border-gray-300 focus:ring-blue-500 dark:focus:ring-blue-600 dark:ring-offset-gray-800 focus:ring-2 dark:bg-gray-700 dark:border-gray-600" />
                    <label htmlFor="default-radio-2" className="ml-2 text-sm font-medium text-gray-900 dark:text-zinc-400">Enterprise</label>
                  </div>
                </div>
                {isEnterprise && <div className="enterprise-form">
                  Enterprise form
                  <br />
                  <div className="grid grid-cols-3 md:grid-cols-2 lg:grid-cols-3 gap-3">
                    <TextField
                      label="Company Name"
                      placeholder={"Enter your company name"}
                      inputProps={{ ...register("companyName", { required: true }) }}
                    />
                    <TextField
                      label="Company GST"
                      placeholder={"Enter your company gst"}
                      inputProps={{ ...register("companyGST", { required: true }) }}
                    />
                    <TextField
                      label="Company Mobile"
                      type="number"
                      placeholder={"Enter your company mobile number"}
                      inputProps={{ ...register("companyMobile", { required: true }) }}
                    />
                    <TextField
                      label="Company Email"
                      placeholder={"Enter your company email"}
                      inputProps={{ ...register("companyEmail", { required: true }) }}
                    />
                    <TextField
                      label="Company Address"
                      placeholder={"Enter your company address"}
                      inputProps={{ ...register("companyAddress", { required: true }) }}
                    />
                  </div>
                </div>
                }
              </div>
            </div>

          </div>
          <a
            href="/login"
            className="text-tblu hover:underline cursor-pointer w-full"
          >
            Already a user? Login here
          </a>
          <br />
          <br />
          <button
            onClick={handleSubmit(submitlogin)}
            className="text-xl bg-tblu text-white grid items-center w-full p-4 rounded-xl"
          >
            {isLoading ? <Spinner /> : "Register"}
          </button>
        </form>
      </div>
    </div>
  );
};

export default SignUpPage;
